import { NgModule, ErrorHandler, LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeDE from '@angular/common/locales/de';
registerLocaleData(localeDE);

import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';
/*Components*/

/*Chat*/
import { LoginPage } from '../pages/login/login';
import { CheckpinPage } from '../pages/checkpin/checkpin';
import { SettingsPage } from '../pages/settings/settings';
import { TabsPage } from '../pages/tabs/tabs';
import { MessagesPage } from '../pages/messages/messages';
import { GroupsPage } from '../pages/groups/groups';
import { FriendsPage } from '../pages/friends/friends';
import { MessagePage } from '../pages/message/message';
import { ImageModalPage } from '../pages/image-modal/image-modal';
import { GroupPage } from '../pages/group/group';
import { GroupInfoPage } from '../pages/group-info/group-info';
import { NewGroupPage } from '../pages/new-group/new-group';
import { AddMembersPage } from '../pages/add-members/add-members';
import { UserInfoPage } from '../pages/user-info/user-info';

import { ChatPage} from '../pages/chat/chat';
import { ChatSinglePage} from '../pages/chat-single/chat-single';
import { ChatNewPage} from '../pages/chat-new/chat-new';
import { ChatGroupPage} from '../pages/chat-group/chat-group';
import { ChatGroupInfoPage} from '../pages/chat-group-info/chat-group-info';
import { ChatGroupAddPage} from '../pages/chat-group-add/chat-group-add';
import { ChatGroupAddMemberPage} from '../pages/chat-group-add-member/chat-group-add-member';
/*Basic App */
import { DashboardPage } from '../pages/dashboard/dashboard';
import { GuestdashboardPage } from '../pages/guestdashboard/guestdashboard';
import { MessagecenterPage } from '../pages/messagecenter/messagecenter';
import { MessagecenterReadPage } from '../pages/messagecenter-read/messagecenter-read';
import { PrivacyPolicyPage } from '../pages/privacy-policy/privacy-policy';
import { QrscannerPage } from '../pages/qrscanner/qrscanner';
import { RegisterPage } from '../pages/register/register';
import { RegisterRequestPage } from '../pages/register-request/register-request';

import { UsermenuPopoverPage } from '../pages/usermenu-popover/usermenu-popover';
/*App Modules */
import { PhonebookPage } from '../pages/phonebook/phonebook';
import { PhonebookProfilePage } from '../pages/phonebook-profile/phonebook-profile';
import { IdeapoolPage } from '../pages/ideapool/ideapool';
import { IdeapoolAddPage } from '../pages/ideapool-add/ideapool-add';
import { WorkplanPage } from '../pages/workplan/workplan';
import { WorkplanUserPage } from '../pages/workplan-user/workplan-user';
import { WorkplanDetailsPage } from '../pages/workplan-details/workplan-details';
import { NewsPage } from '../pages/news/news';
import { NewsReadPage } from '../pages/news-read/news-read';
import { VacationPage } from '../pages/vacation/vacation';
import { VacationAddPage } from '../pages/vacation-add/vacation-add';
import { VacationCalendarPage } from '../pages/vacation-calendar/vacation-calendar';
import { VacationDetailsPage } from '../pages/vacation-details/vacation-details';
import { CmsPage } from '../pages/cms/cms';
import { MagazinePage } from '../pages/magazine/magazine';
import { MagazineLandingPage } from '../pages/magazine-landing/magazine-landing';
import { JobsPage } from '../pages/jobs/jobs';
import { JobsDetailsPage } from '../pages/jobs-details/jobs-details';
import { EventsPage } from '../pages/events/events';
import { EventsDetailsPage } from '../pages/events-details/events-details';
import { ContactPage } from '../pages/contact/contact';
import { IdcardPage } from '../pages/idcard/idcard';
import { MarketplaceAddPage } from '../pages/marketplace-add/marketplace-add';
import { MarketplaceItemPage } from '../pages/marketplace-item/marketplace-item';
import { MarketplacePage } from '../pages/marketplace/marketplace';
import { MarketplaceEditPage } from '../pages/marketplace-edit/marketplace-edit';
import { BrowserPage } from '../pages/browser/browser';
import { WallPage } from '../pages/wall/wall';
import { WallAddPage } from '../pages/wall-add/wall-add';
import { SickcertificatePage } from '../pages/sickcertificate/sickcertificate';
import { FilesPage } from '../pages/files/files';
import { FileReadPage } from '../pages/file-read/file-read';

/*Webfleet*/
import {WebfleetReportListPage} from "../pages/webfleet-report-list/webfleet-report-list";
import { WebfleetReportOverviewPage } from '../pages/webfleet-report-overview/webfleet-report-overview';
import { WebfleetReportPage } from '../pages/webfleet-report/webfleet-report';
import { WebfleetChooseWorkPage} from "../pages/webfleet-choose-work/webfleet-choose-work";
import {WebfleetAddPositionPage} from "../pages/webfleet-add-position/webfleet-add-position";
import {WebfleetSignaturePadPage} from "../pages/webfleet-signature-pad/webfleet-signature-pad";


import { LoginProvider } from '../providers/login';
import { LogoutProvider } from '../providers/logout';
import { LoadingProvider } from '../providers/loading';
import { AlertProvider } from '../providers/alert';
import { ImageProvider } from '../providers/image';
import { DataProvider } from '../providers/data';
import { FirebaseProvider } from '../providers/firebase';
import { UserProvider } from '../providers/user';
import { TeamappProvider } from '../providers/teamapp';
import { MessageProvider } from '../providers/message';

import { NgCalendarModule  } from 'ionic2-calendar';
import { QRCodeModule } from 'angularx-qrcode';

import { Settings } from '../settings';

import { FriendPipe } from '../pipes/friend';
import { SearchPipe } from '../pipes/search';
import { ConversationPipe } from '../pipes/conversation';
import { DateFormatPipe } from '../pipes/date';
import { GroupPipe } from '../pipes/group';
import { UsersearchPipe } from '../pipes/usersearch/usersearch';
import { ChatsearchPipe} from '../pipes/chatsearch/chatsearch';

import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { Camera } from '@ionic-native/camera';
import { Keyboard } from '@ionic-native/keyboard';
import { Contacts } from '@ionic-native/contacts';
import { MediaCapture } from '@ionic-native/media-capture';
import { File } from '@ionic-native/file';
import { FileTransfer } from '@ionic-native/file-transfer';
import { FileOpener } from '@ionic-native/file-opener';
import { Geolocation } from '@ionic-native/geolocation';
import { SQLite} from '@ionic-native/sqlite';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { QRScanner } from '@ionic-native/qr-scanner';
import { Calendar } from '@ionic-native/calendar';
import { PhotoLibrary } from '@ionic-native/photo-library';

import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';

import { FriendsFilterPage } from '../pages/friends-filter/friends-filter';

import { AlphascrollComponent } from '../components/alphascroll/alphascroll';

import { AccordionComponent } from '../components/accordion/accordion';
import { ReactionComponent } from '../components/reaction/reaction';

import { IonicImageViewerModule } from 'ionic-img-viewer';
import { SignaturePadModule } from 'angular2-signaturepad';


@NgModule({
  declarations: [
    MyApp,
    /*Chat*/
    LoginPage,
    CheckpinPage,
    SettingsPage,
    TabsPage,
    MessagesPage,
    ImageModalPage,
    GroupsPage,
    GroupInfoPage,
    FriendsPage,
    MessagePage,
    GroupPage,
    NewGroupPage,
    AddMembersPage,
    UserInfoPage,
    FriendsFilterPage,

    ChatPage,
    ChatSinglePage,
    ChatNewPage,
    ChatGroupPage,
    ChatGroupInfoPage,
    ChatGroupAddPage,
    ChatGroupAddMemberPage,
    /*App Basics*/
    DashboardPage,
    GuestdashboardPage,
    PrivacyPolicyPage,
    MessagecenterPage,
    MessagecenterReadPage,
    CmsPage,
    MagazinePage,
    MagazineLandingPage,
    RegisterPage,
    RegisterRequestPage,
    QrscannerPage,
    /*App Modules*/
    PhonebookPage,
    PhonebookProfilePage,
    IdeapoolPage,
    IdeapoolAddPage,
    WorkplanPage,
    WorkplanDetailsPage,
    WorkplanUserPage,
    NewsPage,
    NewsReadPage,
    VacationPage,
    VacationAddPage,
    VacationCalendarPage,
    VacationDetailsPage,
    JobsPage,
    JobsDetailsPage,
    EventsPage,
    EventsDetailsPage,
    ContactPage,
    IdcardPage,
    MarketplaceAddPage,
    MarketplaceItemPage,
    MarketplacePage,
    MarketplaceEditPage,
    BrowserPage,
    WallPage,
    WallAddPage,
    SickcertificatePage,
    FilesPage,
    FileReadPage,
    /*Webfleet*/
    WebfleetReportOverviewPage,
    WebfleetReportPage,
    WebfleetReportListPage,
    WebfleetChooseWorkPage,
    WebfleetAddPositionPage,
    WebfleetSignaturePadPage,

    /*Popovers*/
    UsermenuPopoverPage,

    FriendPipe,
    ConversationPipe,
    SearchPipe,
    DateFormatPipe,
    GroupPipe,
    UsersearchPipe,
    ChatsearchPipe,

    AlphascrollComponent,
    AccordionComponent,
    ReactionComponent

  ],
  imports: [
    IonicModule.forRoot(MyApp, {
      scrollAssist: false,
      autoFocusAssist: false,
      backButtonText: 'Zurück',
      //mode: 'ios',
      tabsPlacement: 'top'
    }),
    BrowserModule,
    IonicImageViewerModule,
    HttpModule,
    NgCalendarModule,
    QRCodeModule,
    SignaturePadModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    /*Chat*/
    LoginPage,
    CheckpinPage,
    SettingsPage,
    TabsPage,
    MessagesPage,
    GroupsPage,
    FriendsPage,
    MessagePage,
    ImageModalPage,
    GroupPage,
    GroupInfoPage,
    NewGroupPage,
    AddMembersPage,
    UserInfoPage,
    FriendsFilterPage,

    ChatPage,
    ChatSinglePage,
    ChatNewPage,
    ChatGroupPage,
    ChatGroupInfoPage,
    ChatGroupAddPage,
    ChatGroupAddMemberPage,
    /*App Basics*/
    DashboardPage,
    GuestdashboardPage,
    MessagecenterPage,
    MessagecenterReadPage,
    CmsPage,
    MagazinePage,
    MagazineLandingPage,
    RegisterPage,
    RegisterRequestPage,
    PrivacyPolicyPage,
    QrscannerPage,
    /*App Modules*/
    PhonebookPage,
    PhonebookProfilePage,
    IdeapoolPage,
    IdeapoolAddPage,
    WorkplanPage,
    WorkplanDetailsPage,
    WorkplanUserPage,
    NewsPage,
    NewsReadPage,
    VacationPage,
    VacationAddPage,
    VacationCalendarPage,
    VacationDetailsPage,
    JobsPage,
    JobsDetailsPage,
    EventsPage,
    EventsDetailsPage,
    ContactPage,
    IdcardPage,
    MarketplaceAddPage,
    MarketplaceItemPage,
    MarketplacePage,
    MarketplaceEditPage,
    BrowserPage,
    WallPage,
    WallAddPage,
    SickcertificatePage,
    FilesPage,
    FileReadPage,
    /*Webfleet*/
    WebfleetReportOverviewPage,
    WebfleetReportPage,
    WebfleetReportListPage,
    WebfleetChooseWorkPage,
    WebfleetAddPositionPage,
    WebfleetSignaturePadPage,

    /*Popovers*/
    UsermenuPopoverPage,
  ],
  providers: [
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    SplashScreen,
    StatusBar,
    Camera,
    Keyboard,
    Contacts,
    MediaCapture,
    File,
    FileTransfer,
    FileOpener,
    Geolocation,
    SQLite,
    InAppBrowser,
    QRScanner,
    Calendar,
    PhotoLibrary,

    LoginProvider,
    LogoutProvider,
    LoadingProvider,
    AlertProvider,
    ImageProvider,
    DataProvider,
    FirebaseProvider,
    UserProvider,
    TeamappProvider,
    MessageProvider]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts